import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import ability, { updateAbilities } from './ability'

Vue.use(abilitiesPlugin, ability)

// Export updateAbilities for use in components
export { updateAbilities }
export default ability
